<template>
<!-- 这是部门主管进入请假的页面 -->
    <div class="addLeave">
        <div class="box">
            <div class="box-1" @click="people">
                <div class="box-1-l">
                    <span>请假人</span>
                    <span>{{name}}</span>
                </div>
                <div class="box-1-r"></div>
            </div>
            <div class="box-1" @click="time">
                <div class="box-1-l">
                    <span>开始时间</span>
                    <span>{{startTime}}</span>
                </div>
                <div class="box-1-r"></div>
            </div>
            <div class="box-1" @click="times">
                <div class="box-1-l">
                    <span>结束时间</span>
                    <span>{{endTime}}</span>
                </div>
                <div class="box-1-r"></div>
            </div>
            <div class="box-2" style="">
                <div class="box-2-t">事由</div>
                <textarea class="textarea" style="width:100%;height:7rem;border:1px solid #ccc;text-indent:10px" v-model="leaveReason" placeholder="请输入请假事由..."></textarea>
            </div>
            <div class="box-1" style="margin-top:4rem">
                    <span>是否自动审批</span>
                    <van-switch v-model="checked" size="20px" active-color="#00B893" inactive-color="#dcdee0" style="border:0px;" @change="change"/>
            </div>
            <div class="box-1" v-if="!checked" style="">
                <div class="box-1-l">
                    <span>审批人</span>
                    <span>{{shenpiname}}</span>
                </div>
                <div class="box-1-r" @click="shenpiren"></div>
            </div>
        </div>
        <van-button type="primary" class="btn" @click="btn">提交</van-button>
        <van-action-sheet v-model="show">
            <van-datetime-picker
            @confirm="confirm"
            v-model="currentDate"
            type="datetime"
            title="选择时间"
            />
        </van-action-sheet>
        <van-action-sheet v-model="shows">
            <van-datetime-picker
            @confirm="confirms"
            v-model="currentDates"
            type="datetime"
            title="选择时间"
            />
        </van-action-sheet>
    </div>
</template>

<script>
import { getLeave } from "@/api/http"
import Vue from 'vue';
import { Button,DatetimePicker,ActionSheet,Switch,Toast  } from 'vant';
Vue.use(Button);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Switch);
Vue.use(Toast);
export default {
    data(){
        return{
            currentDate: new Date(),
            currentDates: new Date(),
            checked:false,
            show:false,//开始时间弹出框
            shows:false,//结束时间弹出框
            startTime:"",//开始时间
            endTime:"",//结束时间
            userInfo:JSON.parse(window.sessionStorage.getItem("userInfo")),//当前登陆人的信息
            currentInfo:JSON.parse(window.sessionStorage.getItem("currentInfo")),//当前登陆人的信息
            date:null,//接受传递过来的请假人员信息
            name:"",//请假人姓名
            shenpiname:"请选择",//审批人的名字
            shenpidate:null,//审批人的信息
            leaveReason:"",//请假事由
            canshu:"",//请假参数
        }
    },
    methods:{
        btn(){
            let that = this
            if(this.name === ""){
                Toast.fail('请填写请假人')
            }
            else if(this.checked === false && this.shenpiname === "请选择"){
                 Toast.fail('请填写审批人')
            }
            else if(this.startTime === ""){
                Toast.fail('请选择开始时间')
            }
            else if(this.endTime === ""){
                Toast.fail('请选择结束时间')
            }
            else if(this.leaveReason === ""){
                Toast.fail('请填写请假事由')
            }
            else if((this.name != "" && this.startTime != "" && this.endTime != "" && this.leaveReason != "" && this.checked === true) || (this.name != "" && this.startTime != "" && this.endTime != "" && this.leaveReason != "" && this.checked === false && this.shenpiname !== "请选择")){
                console.log("aaaaaaaaaaaaaaaaaa")
                if(this.checked === true){
                    this.canshu = {
                        "submitterId":this.userInfo.id,
                        "leaverIds":[this.date[0].id],
                        "forwardUserId":null,
                        "leaveReason":this.leaveReason,
                        "leaveState":14,
                        "startTime":this.currentDate,
                        "endTime":this.currentDates
                    }
                }else{
                    this.canshu = {
                        "submitterId":this.userInfo.id,
                        "leaverIds":[this.date[0].id],
                        "forwardUserId":this.shenpidate[0].id,
                        "leaveReason":this.leaveReason,
                        "leaveState":14,
                        "startTime":this.currentDate,
                        "endTime":this.currentDates
                    }
                }
                getLeave(this.canshu).then(res=>{
                    if(res.data.code === 200 ){
                        console.log(res.data.data)
                        window.sessionStorage.removeItem("date")
                        window.sessionStorage.removeItem("dates")
                        let time = this.currentDates.getTime() - this.currentDate.getTime()
                        console.log(time)
                        let newTime = that.computedTime(time)
                        this.$router.push({
                            path:"/successLeave",
                            query:{
                                data:{
                                    name:this.name,
                                    leaveReason:this.leaveReason,
                                    time:newTime
                                }
                            }
                        })
                    }else{
                        Toast.fail(res.data.msg)
                    }
                })
            }
            
        },
        people(){
            console.log(this.currentInfo)
            if(this.currentInfo.roles.length === 1 && this.currentInfo.roles[0].id === 5){
                this.$router.push("/people")
            }else{
                this.currentInfo.roles.forEach(item=>{
                    if(item.id === 6){
                        this.$router.push("/class")
                    }
                })
            }
        },
        time(){
            this.show = true
        },
        times(){
            this.shows = true
        },
        shenpi(){

        },
        shenpiren(){
            this.$router.push("/shenpi")
        },
        change(){
            console.log(this.checked)
        },
        confirm(){
            this.startTime = this.timeFormat(this.currentDate)
            console.log(this.currentDate)
            console.log(this.startTime)
            this.show = false
        },
        confirms(){
            this.endTime = this.timeFormat(this.currentDates)
            console.log(this.currentDates)
            console.log(this.startTime)
            this.shows = false
        },
        //时间格式化
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            let hour = time.getHours();
            let minute = time.getMinutes();
            let second = time.getSeconds();
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
        },
        //计算时间
        computedTime(time){
            let h = time/1000/60/60
            if(h<24){
                return h+"小时"
            }
            if(h === 24 ){
                return 1 + "天"
            }
            if(h > 24){
                return parseInt(h/24) + "天" + (h % 24) + "小时"
            }
        }
    },
    mounted(){
        if(this.$route.query.date){
            this.date = this.$route.query.date
            this.name = this.date[0].name
            console.log(this.$route.query.date)
        }
        if(window.sessionStorage.getItem("date") !== null){
            this.shenpidate = JSON.parse(window.sessionStorage.getItem("date"))
            this.shenpiname = this.shenpidate[0].name
        }
        if(window.sessionStorage.getItem("dates") !== null){
            this.date = JSON.parse(window.sessionStorage.getItem("dates"))
            this.name = this.date[0].name
        }
        
    }
}
</script>

<style scoped>
    .addLeave{
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #fff;
    }
    .box{
      width: calc(100% - 2rem);
      margin: 0 auto;
      background-color: #fff;
    }
    .btn{
        background-color: #FFA900;
        width: 21.44rem;
        height: 2.75rem;
        border: 0px;
        position: fixed;
        bottom: 2rem;
        font-size: 1.19rem;
        left: 50%;
        transform: translate(-50%);
        border-radius: 0.25rem;
    }
    .box-1{
        height: 3.34rem;
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .box-1-l{
        width: 95%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .box-1-l span:nth-child(1){
        font-size: 1rem;
        color: #333;
    }
    .box-1-l span:nth-child(2){
        font-size: 0.88rem;
        color: #666;
    }
    .box-1-r{
        width: 0.44rem;
        height: 0.75rem;
        background: url("../img/kuohao.png");
        background-size:100% 100%;
    }
    .box-2{
        height: 7.25rem;
        width: 100%;
    }
    .box-2-t{
        height: 3.31rem;
        width: 100%;
        color: #333;
        line-height: 3.31rem;
    }
    .textarea{
        width: 100%;
        height: 3.94rem;
    }
</style>